import toast from "react-hot-toast";

import { store } from "../store";
import { AuthCode } from "../constants";
import { SIGN_OUT } from "../store/actions";

export const handleFetchError = async (res) => {
    if (res.status >= AuthCode.BAD_REQUEST && res.status < AuthCode.CONNECTION_TIMED_OUT) {
        const response = await res.clone().json();
        let errRes = {
            ...response,
            Message: response.message,
            Status: res.status
        };

        // Extract specific error message if available
        let errorMessage = response.message;
        if (response.errors && typeof response.errors === "object") {
            const errorKeys = Object.keys(response.errors);
            if (errorKeys.length > 0) {
                errorMessage = response.errors[errorKeys[0]]; // Show first error message dynamically
            }
        }

        if (res.status === AuthCode.UNAUTHORIZED) {
            store.dispatch({ type: SIGN_OUT });
            localStorage.clear();
        }

        console.log("response", response, errRes);
        toast.error(errorMessage); // Show specific error message
        throw errRes;
    }
    return res.json();
};
